/* eslint-disable @typescript-eslint/no-unused-vars */
import AuthLayout from "@/components/layouts/AuthLayout";
import { getCouncilProfileUrl, useGetAllCouncils } from "@/services/councils";
import { ECouncilName } from "@/types";
import { Button, Card, Paper } from "@mantine/core";
import { EmptyView, LoadingView } from "moh-ui";
import React, { useState } from "react";
import { PiPlaceholder } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

const ALLOWED_COUNCILS = [ECouncilName.NPC, ECouncilName.RMDC];

const HomePage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { data: councils, isLoading: loading } = useGetAllCouncils();

  const handleCreateAccountClick = (council: {
    id: string;
    councilCode: string;
  }) => {
    /*if (council.councilCode === ECouncilName.RMDC) {
      window.location.href = "/auth/forgot-password-bylicense";
    } else {*/
    navigate(`/create-account/CreateAccount?council=${council.id}`);
    //}
  };

  return (
    <AuthLayout maxWidth="max-w-5xl">
      {/* Alert Box */}
      <Paper className="bg-green-100 text-green-800 border border-green-200 p-5 rounded-lg font-sans max-w-3xl mx-auto my-5 ">
        <p className="font-bold mb-2">Important Information:</p>
        <p className="leading-relaxed">
          If you're new to this platform or don't have an account yet, please
          visit the council where you'll be creating your account. Look for the{" "}
          <strong>"Create Account"</strong> button, and you will be prompted to
          fill in your details to set up your account.
        </p>
      </Paper>

      {/* Main Container */}
      {loading ? (
        <LoadingView message="Loading Councils..." />
      ) : error ? (
        <EmptyView message="Error fetching councils data." />
      ) : (
        <div className="bg-gray-100 pb-8 rounded-md">
          <div className="container mx-auto px-4">
            {/* Cards Container */}
            <div className="grid md:grid-cols-2 gap-5 p-5">
              {councils?.data.map((council) => (
                <Card
                  withBorder
                  key={council.id}
                  className="rounded-md flex flex-col justify-between"
                >
                  <div className="flex items-center gap-5 mb-4">
                    {council.councilProfileDocumentPath ? (
                      <img
                        src={getCouncilProfileUrl(
                          council.councilProfileDocumentPath
                        )}
                        alt={`Logo for ${council.councilCode}`}
                        className="w-12 h-auto"
                      />
                    ) : (
                      <div className="w-12 h-12 bg-gray-200 flex items-center justify-center rounded-full">
                        <PiPlaceholder className="text-gray-400 text-2xl" />
                      </div>
                    )}
                    <div>
                      <h3 className="text-xl font-bold m-0">
                        {council.councilCode}
                      </h3>
                      <p className="text-gray-600 m-0">{council.councilName}</p>
                    </div>
                  </div>
                  <div className="w-full">
                    <hr className="my-3 border-gray-200" />
                    <Button
                      onClick={() => handleCreateAccountClick(council)}
                      disabled={
                        !ALLOWED_COUNCILS.includes(
                          council.councilCode as ECouncilName
                        )
                      }
                      className="w-full"
                    >
                      Create Account
                    </Button>
                  </div>
                </Card>
              ))}
            </div>

            {/* Login Button */}
            <div className="text-center mt-5 mb-3">
              <Button
                size="lg"
                onClick={() => navigate("/auth/login")}
                variant="outline"
              >
                Already have an account? Click to login !
              </Button>
            </div>
          </div>
        </div>
      )}
    </AuthLayout>
  );
};

export default HomePage;
